import{useDiContainerProviderContext as e}from"./use-di-container-provider-context.js";const o=n=>{const{diContainer:t}=e();return t.get(n)};export{o as useDiContainerInjection};
